module.exports = __webpack_public_path__ + "fk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/fk.svg
// module id = 545
// module chunks = 0